import BackLayoutMain from "../components/backLayout/main";

import BackAccountList from "../page/back/account";
import BackAccountDetail from "../page/back/account/detail";
import BackReportList from "../page/back/report";

const routes = [
  {
    path: "back",
    element: <BackLayoutMain />,
    children: [
      {
        path: "account",
        element: <BackAccountList />,
      },
      {
        path: "account/:detailid",
        element: <BackAccountDetail />,
      },
      {
        path: "report",
        element: <BackReportList />,
      },
      {
        path: "*",
        element: <>無畫面</>,
      },
    ],
  },
];

export default {
  routes,
};
